function tabs(theme) {
    return {
        componentName: 'tabs',
        baseStyle: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.space['xs-s'],
            flex: 1
        }
    };
}

export { tabs as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFicy5qcyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL3RoZW1lL2NvbXBvbmVudHMvdGFicy90YWJzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEJhc2VUaGVtZSB9IGZyb20gJy4uLy4uL2Jhc2VUaGVtZSc7XG5pbXBvcnQgeyBDb21wb25lbnRTdHlsZSB9IGZyb20gJy4uLy4uL3R5cGVzJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdGFicyh0aGVtZTogQmFzZVRoZW1lKTogQ29tcG9uZW50U3R5bGUge1xuICByZXR1cm4ge1xuICAgIGNvbXBvbmVudE5hbWU6ICd0YWJzJyxcbiAgICBiYXNlU3R5bGU6IHtcbiAgICAgIGRpc3BsYXk6ICdmbGV4JyxcbiAgICAgIGZsZXhEaXJlY3Rpb246ICdjb2x1bW4nLFxuICAgICAgZ2FwOiB0aGVtZS5zcGFjZVsneHMtcyddLFxuICAgICAgZmxleDogMVxuICAgIH1cbiAgfTtcbn1cbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHd0IsU0FBQSxJQUFJLENBQUMsS0FBZ0IsRUFBQTtJQUMzQyxPQUFPO0FBQ0wsUUFBQSxhQUFhLEVBQUUsTUFBTTtBQUNyQixRQUFBLFNBQVMsRUFBRTtBQUNULFlBQUEsT0FBTyxFQUFFLE1BQU07QUFDZixZQUFBLGFBQWEsRUFBRSxRQUFRO0FBQ3ZCLFlBQUEsR0FBRyxFQUFFLEtBQUssQ0FBQyxLQUFLLENBQUMsTUFBTSxDQUFDO0FBQ3hCLFlBQUEsSUFBSSxFQUFFO0FBQ1A7S0FDRjtBQUNIOzs7OyJ9
